import {Component, ElementRef, OnInit} from '@angular/core';
import {ViewMode} from "../../../models/type/view-mode.enum";
import {BaseRendererComponent} from "../base-renderer/base-renderer.component";
import {UserService} from "../../../services/user/user.service";

declare var moment;

@Component({
  selector: 'sb-time-renderer',
  templateUrl: './time-renderer.component.html',
  styleUrls: ['./time-renderer.component.scss']
})
export class TimeRendererComponent extends BaseRendererComponent implements OnInit {

  constructor(private hostElement: ElementRef<HTMLElement>,
              private userService: UserService) {
    super();
  }

  ngOnInit(): void {
  }

  timeValue() {
    const value = this.fieldValue();
    const date = moment(value);
    return new Date(date.toDate().getTime());
  }

  timeFormat() {
    return this.userService.getLongTimeFormatCLDR();
  }

  enabled() {
    return !(this.elementOrViewModeReadOnly());
  }

  readOnlyTimeValue() {
    const value = this.fieldValue(); // ISO string
    const date = moment(value);
    const format = this.userService.getLongTimeFormat() + (this.userService.isAMPMTime() ? " A" : "");
    return date.format(format);
  }

}
